·<template>
  <el-container>
    <el-main class="topman">
      <!-- 路由占位符-->
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data () {
    return {}
  },
  watch: {},
  created () {
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
